'use client';

import { useLocale, useTranslations } from 'next-intl';
import { usePathname, useRouter } from '@/i18n/navigation';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { routing } from '@/i18n/routing';

export function LanguageSelector() {
  const locale = useLocale();
  const t = useTranslations('LanguageSelector');
  const router = useRouter();
  const pathname = usePathname();

  const switchLocale = (nextLocale: string) => {
    router.replace(pathname, { locale: nextLocale });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-[#233554] hover:border-[#64ffda] text-[#a8b2d1] hover:text-[#64ffda] transition-colors text-sm"
          aria-label={t('label')}
        >
          <Globe className="w-4 h-4" />
          <span className="uppercase font-medium">{locale}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#112240] border-[#233554] text-white min-w-[130px]"
      >
        {routing.locales.map((loc) => (
          <DropdownMenuItem
            key={loc}
            onClick={() => switchLocale(loc)}
            className={`cursor-pointer gap-2 ${
              loc === locale
                ? 'text-[#64ffda] bg-[#0a192f]'
                : 'text-[#a8b2d1] hover:text-[#64ffda] hover:bg-[#0a192f] focus:text-[#64ffda] focus:bg-[#0a192f]'
            }`}
          >
            <span className="uppercase text-xs font-mono opacity-60">{loc}</span>
            {t(loc as 'fr' | 'en')}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
